export default {
	singular: 3,
	plural: 4,
	changePassword: 282,
	lastName: 487,
	documentNumber: 585,
	documentEndDate: 587,
	inviteUser: 625,
	invite: 626,
	identityProvider: 749,
	customAccess: 961,
	contactPerson: 2409,
	fullName: 3363,
	rejectDeleteRequest: 4463,
	preferedLanguage: 5197,
	expirationDate: 5198,
	lastLoginDate: 5235,
	lastLoginBrowser: 5236,
	lastLoginDevice: 5237,
	confirmationDeleteTitle: 5487,
	confirmationDeleteDescription: 5488,
	noRoleSelected: 10516,
	emailPreview: {
		reason: 10524,
		description: 10525,
	},
	changePasswordModal: {
		change: 10859,
	},
	myOffice: 12314,
	changes: 13606,
	logins: 13607,
	activeOrganization: 13908,
	ownership: 13964,
	transferOwnership: 13970,
	activityOwner: 13979,
	activityAssignee: 13980,
	transferOwnershipStep1Description: 13985,
	transferFrom: 13986,
	transferTo: 13987,
	transfer: 13988,
	sendingAlertsWarningMessage: 14002,
	noUserAccessTipMessage: 14005,
	passwordBlackListValidation: 14843,
	pauseTimecardAlert: 15968,
	useForDocumentAlert: 15969,
};
